// React
import { FC, useState } from 'react';

import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { RootState } from '@/store/store';
import { selectUser } from '@/store/slices/authSlice';

import { inviteMember } from '@/app/api';
import { ROLE_OPTIONS } from '@/consts/role';

import { Input } from '../../inputs';
import { Button } from '../../button';
import Modal from '../../modal';
import SuccessModal from './SuccessModal';
import ErrorModal from '../ErrorModal';
import Select from '@/components/select';

import UserGIF from '@/assets/modal/user.gif';

interface IFormModal {
  isOpen: boolean;
  setIsOpen: (status: boolean) => void;
}

export interface IFormData {
  email: string;
  role: number;
  author_id: number;
  company_id: number;
}

const FormModal: FC<IFormModal> = ({ isOpen, setIsOpen }) => {
  const [isOpenSuccess, setIsOpenSuccess] = useState<boolean>(false);
  const [isOpenError, setIsOpenError] = useState<boolean>(false);

  const user = useSelector(selectUser);
  const currentCompany = useSelector(
    (state: RootState) => state.company.currentCompany
  );

  const { register, handleSubmit } = useForm<IFormData>({
    defaultValues: { author_id: user?.id, company_id: currentCompany?.id },
  });

  const onClose = () => {
    setIsOpen(false);
  };

  const onSubmit = (data: IFormData) => {
    inviteMember(data)
      .then(() => {
        onClose();

        setIsOpenSuccess(true);
      })
      .catch(() => setIsOpenError(true));
  };

  return (
    <>
      <Modal open={isOpen} onClose={onClose} className="bg-white">
        <div className="bg-[#192c46] text-white text-center py-3 rounded-t-lg">
          <div className="flex flex-col items-center">
            <img src={UserGIF} alt="user" className="w-[40px] h-[40px]" />
            <p className="text-[28px] font-jostMedium">Send invitation</p>
          </div>
        </div>
        <form
          className="p-7 flex flex-col items-center"
          onSubmit={handleSubmit(onSubmit)}>
          <p className="text-center text-[22px] text-[#1F2B40] font-jostRegular">
            Tilføj venligst e-mailadressen på din kollega, som du gerne vil
            invitere til CloudCollect
          </p>
          <div className="flex flex-col gap-6">
            <Select options={ROLE_OPTIONS} {...register('role')} />
            <Input
              placeholder="e-mail"
              type="email"
              className="!text-[#1F2B40CC] !font-jostRegular placeholder:text-[#1F2B40CC]/80"
              {...register('email', { required: `Påkrævet felt E-Mail` })}
            />
          </div>
          <Button
            className="w-[201px] h-[40px] bg-[#1F2B40] !font-jostRegular mt-6"
            type="submit">
            Send
          </Button>
        </form>
      </Modal>

      <SuccessModal isOpen={isOpenSuccess} setIsOpen={setIsOpenSuccess} />
      <ErrorModal isOpen={isOpenError} setIsOpen={setIsOpenError} />
    </>
  );
};

export default FormModal;
